export default "__VITE_ASSET__9a76fdad__"